// Webrtc plugin.
import * as eventTypes from '../eventTypes'
import * as actionTypes from '../actionTypes'

// Other plugins.
import { getCallByWebrtcSessionId } from '../../../call/interfaceNew/selectors'

const events = {}

events[actionTypes.MUTE_TRACKS_FINISH] = action => {
  return {
    type: eventTypes.TRACKS_MUTED,
    args: {
      trackIds: action.payload.trackIds,
      tracks: action.payload.trackIds
    }
  }
}

events[actionTypes.UNMUTE_TRACKS_FINISH] = action => {
  return {
    type: eventTypes.TRACKS_UNMUTED,
    args: {
      trackIds: action.payload.trackIds,
      tracks: action.payload.trackIds
    }
  }
}

events[actionTypes.TRACK_SOURCE_MUTED] = action => {
  // Issue an event containing parameters similar to what call:trackEnded event has.
  return {
    type: eventTypes.TRACK_SOURCE_MUTED,
    args: {
      trackIds: action.payload.trackIds,
      trackId: action.payload.trackIds[0],
      isLocal: action.payload.isLocal,
      id: action.payload.mediaId
    }
  }
}

events[actionTypes.TRACK_SOURCE_UNMUTED] = action => {
  // Issue an event containing parameters similar to what call:trackEnded event has.
  return {
    type: eventTypes.TRACK_SOURCE_UNMUTED,
    args: {
      trackIds: action.payload.trackIds,
      trackId: action.payload.trackIds[0],
      isLocal: action.payload.isLocal,
      id: action.payload.mediaId
    }
  }
}

events[actionTypes.RENDER_TRACKS_FINISH] = action => {
  return {
    type: eventTypes.TRACK_RENDERED,
    args: {
      trackIds: action.payload.trackIds,
      selector: action.payload.selector,
      error: action.payload.error
    }
  }
}

/*
 * Action dispatched when a track ends.
 *
 * If it was a local track that ended by an action outside of the SDK
 *    (ie. is unsolicited), then emit an event to the application as "track
 *    lost" so that it can be handled.
 */
events[actionTypes.SESSION_TRACK_ENDED] = (action, params) => {
  const { trackId, local, isUnsolicited, id } = action.payload
  const call = getCallByWebrtcSessionId(params.state, id)

  if (local && isUnsolicited) {
    return {
      type: eventTypes.TRACK_ENDED,
      args: {
        callId: call.id,
        trackId,
        isLocal: local
      }
    }
  }
}

export default events
